import React from 'react';
export function SectionDivider() {
  return <div className="py-4" data-id="element-320">
      <div className="max-w-7xl mx-auto px-4" data-id="element-321">
        <div className="h-px bg-gray-200 w-full" data-id="element-322"></div>
      </div>
    </div>;
}